import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { ClientDto } from 'api/Clients/Types/Client'
import { TradingAccountFilterKey } from 'api/Clients/Types/TradingAccount'
import { IntroducingBrokerDto } from 'api/Trading-Accounts/Types/IntroducingBrokerDto'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeTradingAccountsSearchQuery = (
  filter: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filter as CompositeFilterDescriptor
  const filters = gridFilterDescriptor.filters.map(
    (filterDescriptor: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = filterDescriptor as FilterDescriptor

      if (filterItem.field === TradingAccountFilterKey.client) {
        return {
          ...filterItem,
          value: filterItem?.value
            ? filterItem.value.map((client: ClientDto) => client.id)
            : filterItem.value,
        }
      }

      if (filterItem.field === TradingAccountFilterKey.wallet) {
        return {
          ...filterItem,
          value: filterItem?.value
            ? filterItem.value.map((walletDto: WalletDto) => walletDto.id)
            : filterItem.value,
        }
      }

      if (filterItem.field === TradingAccountFilterKey.introducingBroker) {
        return {
          ...filterItem,
          value: filterItem?.value
            ? filterItem.value.map((x: IntroducingBrokerDto) => x.id)
            : filterItem.value,
        }
      }

      if (filterItem.field === TradingAccountFilterKey.isInternalTestAccount) {
        const value: boolean = filterItem?.value
        return {
          ...filterItem,
          value: value?.toString() ?? value,
        }
      }

      return filterItem
    }
  )

  return { ...gridFilterDescriptor, filters }
}
